import { useState } from "react";
import { useTranslation } from "react-i18next";

import DetailsCard from "components/DetailsCard";
import {
  StatusExplanation,
  PriorityExplanation,
} from "page_components/shared/tasks/explanations";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";

import useResponsive from "libs/helpers/useResponsive";

import { DeadlineTasksTable, DeadlineTasksTiles } from "./components";

const DeadlineTasks = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const [websiteInfoId, setWebsiteInfoId] = useState(null);
  const [explanation, setExplanation] = useState(null);

  return (
    <>
      <DetailsCard
        title={t("Tasks with upcoming due date")}
        description={t("List of tasks to be completed in the near future.")}
        resetOnMobile
      >
        {!max.lg ? (
          <DeadlineTasksTable
            setWebsiteInfoId={setWebsiteInfoId}
            setExplanation={setExplanation}
          />
        ) : (
          <DeadlineTasksTiles
            setWebsiteInfoId={setWebsiteInfoId}
            setExplanation={setExplanation}
          />
        )}
      </DetailsCard>

      <StatusExplanation
        isOpen={explanation === "status"}
        onClose={() => setExplanation(null)}
      />
      <PriorityExplanation
        isOpen={explanation === "priority"}
        onClose={() => setExplanation(null)}
      />
      <WebsiteInfoModal
        id={websiteInfoId}
        isOpen={!!websiteInfoId}
        onClose={() => setWebsiteInfoId(null)}
      />
    </>
  );
};

export default DeadlineTasks;
